module.exports = __webpack_public_path__ + "media/country_flags/ly-7cf4bb45.png";